<template>
    <section class="config-box">
        <h5 class="font-weight-medium d-flex flex-column flex-sm-row gap-0-5 mb-3">
            {{ title }}
            <strong v-text="activeOption.title" />
        </h5>

        <check-list
            class="config-list"
            type="radio"
            :list="optionsList"
            :selected-rows="selectedRows"
            :select-row="onSelect"
            :disabled-rows="disabledOptions"
        >
            <template #rowDetails="{ row: config }">
                <div class="config-section">
                    <span
                        v-text="config.description"
                        :class="[config.blocked || !config.disabled ? 'text-primary' : 'text-gray']"
                    />
                    <div
                        class="config-img"
                        :class="[
                            { 'config-img--disabled': config.disabled },
                            { 'config-img--blocked': config.blocked }
                        ]"
                    >
                        <div
                            v-for="(icon, idx) of config.icons"
                            :key="idx"
                            class="d-flex align-items-center"
                        >
                            <img
                                class="config-icon"
                                :src="require(`@/assets/img/drs/${icon.img}`)"
                                :style="icon.style"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </check-list>
    </section>
</template>

<script>
import { CONFIG_MODES } from '@/utils/constants/drs/store-config'

export default {
    props: {
        sectionKey: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },

    computed: {
        activeOption() {
            return this.options.find(el => el.isActive)
        },

        selectedRows() {
            return [{ id: this.activeOption.mode, value: true }]
        },

        title() {
            return this.sectionKey === CONFIG_MODES.PACKAGE_COLLECTION
                ? 'Wybrana konfiguracja zbiórki:'
                : 'Wybrany sposób zbiórki opakowań:'
        },

        disabledOptions() {
            return this.optionsList.filter(el => el.disabled && !el.blocked).map(({ id }) => id)
        },

        optionsList() {
        // set tooltip for disabled WPS collection mode
            if (this.sectionKey !== CONFIG_MODES.PACKAGE_COLLECTION) {
                return this.options
            }

            return this.options.map(el => {
                if (el.mode !== 'WPS' || !el.disabled) {
                    return el
                }

                return {
                    ...el,
                    blocked: el.isActive,
                    tooltip: el.isActive
                        ? 'Opcja chwilowo niedostępna. Rekomendujemy zmianę konfiguracji na "Worek na stanowisko"'
                        : 'Opcja chwilowo niedostępna'
                }
            })
        }
    },

    methods: {
        onSelect(mode) {
            if (!mode?.value) return

            this.$emit('change', {
                key: this.sectionKey,
                modeId: mode.id
            })
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.config-box {
    margin-bottom: 2rem;
    .config-list .m-checkList {
        &__row {
            cursor: pointer;
            background-color: var(--color-white);

            .custom-radio {
                font-size: medium;
                font-weight: bold;
                color: var(--color-dark) !important;
            }
        }
        @include media-breakpoint-up(md) {
            &__rows {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 1rem;
            }
            &__row + .m-checkList__row {
                margin: 0;
            }
        }
    }
}

.config-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 130px;
    width: 100%;
    margin-top: 1rem;
    .config-img {
        display: flex;
        justify-content: center;
        gap: 0.25rem;

        &--disabled, &--blocked {
            filter: grayscale(100%);
        }

        .config-icon {
            width: var(--width);
            --width: 65px;
        }
    }
    @include media-breakpoint-down(xs) {
        height: auto;
        gap: 1rem;
        .config-icon {
            --width: 45px !important;
        }
    }
}
</style>